import { Observable } from './zenObservable';
export * from './zenObservable';
export default Observable;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../app_shared/~/zen-observable-ts/lib/index.js
// module id = 94
// module chunks = 1